import '../../components/resource_limit_counter';
import './cadeado.png';
import './concursos.png';
import './index.scss';
import './paywall.erb';
import 'components/freemium/block_message';
import AjaxComponentLoader from 'utils/ajax_component_loader';
import ModalManager from 'utils/modal_manager';
import QuestionComment from '../question_comment';
import QuestionCommentEditor from '../question_comment_editor';
import { EventManager } from 'utils/event_manager';

class QuestionComments {
  constructor(context) {
    this.$context = $(context);

    const { questionId, segmentId, blurComments, totalComments } =
      this.$context.data();
    this.questionId = questionId;
    this.segmentId = segmentId;
    this.blurComments = blurComments;
    this.totalComments = totalComments;

    this._bindCommentEditor();
    this._bindComments();
    this._bindLoadMoreButton();
    this._bindSortButton();
    this._subscribe();

    this.$context.parent().addClass('q-comments-initialized');

    EventManager.subscribe('questionBelt.tabLoaded', (e, { $tabPane }) => {
      this.$context = $('.js-question-comments', $tabPane);

      this._bindCommentEditor();
      this._bindComments();
      this._bindRequestComments();
      this._bindLoadMoreButton();
      this._bindSortButton();
      this._subscribe();
      this._emitEvents(questionId);
    });
  }

  _bindLoadMoreButton() {
    this.$context
      .off('click', '.js-load-more-btn')
      .on('click', '.js-load-more-btn', event =>
        this.loadMoreComments($(event.currentTarget))
      );
  }

  _bindSortButton() {
    if (this.blurComments) {
      this.$context.on('click', '.js-order-by-btn', event =>
        event.preventDefault()
      );
      return;
    }

    this.$context
      .off('click', '.js-order-by-btn')
      .on('click', '.js-order-by-btn', event =>
        this.sort($(event.currentTarget))
      );
  }

  _bindComments() {
    $('.js-question-comment', this._getCommentsListElement()).each(
      (i, questionComment) => {
        if (!questionComment.questionCommentInstance) {
          questionComment.questionCommentInstance = new QuestionComment(
            questionComment
          );
        }
      }
    );
  }

  _bindRequestComments() {
    $('.js-button-request-comment').on('click', e => {
      const $btnFavorite = $(e.currentTarget)
        .parents('.js-question-comments:first')
        .find('.js-favorite.btn-favorite');

      if ($btnFavorite) {
        $btnFavorite.click();
      }
    });
  }

  _bindCommentEditor() {
    const $editor = $('.js-question-comment-editor', this.$context);
    $editor.length && new QuestionCommentEditor($editor);
  }

  _subscribe() {
    EventManager.unsubscribe(`questionBelt.${this.questionId}`);
    EventManager.unsubscribe(`questionComment.${this.questionId}.create`);
    EventManager.unsubscribe(`questionComment.${this.questionId}.update`);
    EventManager.unsubscribe(`questionComment.${this.questionId}.delete`);
    EventManager.unsubscribe(
      `questionBelt.${this.questionId}.comments.updateTotal`
    );
    EventManager.unsubscribe(
      `questionBelt.${this.questionId}.commentsTeachers.updateTotal`
    );

    EventManager.subscribe(
      `questionComment.${this.questionId}.create`,
      this.createComment.bind(this)
    );
    EventManager.subscribe(
      `questionComment.${this.questionId}.update`,
      this.updateComment.bind(this)
    );
    EventManager.subscribe(
      `questionComment.${this.questionId}.delete`,
      this.deleteComment.bind(this)
    );

    EventManager.subscribe(
      `questionBelt.${this.questionId}.comments.updateTotal`,
      this.updateTotalCounter.bind(this)
    );
    EventManager.subscribe(
      `questionBelt.${this.questionId}.commentsTeachers.updateTotal`,
      this.updateTeachersCounter.bind(this)
    );
  }

  _emitEvents(questionId) {
    if (this.$context.data('question-id') === questionId) {
      if (window.currentUser.subscriptionStatus === 'standard') {
        UserTracker.emit('event', {
          eventName: 'student commentary viewed',
          except: ['user'],
          data: {
            comments_quantity: this.totalComments
          }
        });
      }
    }
  }

  _getCommentsListElement() {
    return $('.js-question-comments-list', this.$context);
  }

  _renderComments(html, replace = false) {
    const $html = $(html);
    const data = $html.data();

    if (!data) {
      return;
    }

    const { nextPage, params: newParams } = data;
    const $commentsList = this._getCommentsListElement();
    $commentsList.data('params', newParams);
    $commentsList.data('next-page', nextPage);
    this._getCommentsListElement()[replace ? 'html' : 'append']($html.html());
    this._bindComments();
    global.blazyInstance.revalidate();
  }

  createComment(event, data) {
    QuestionCommentEditor.createAndRender(
      this.questionId,
      this.segmentId,
      data.commentHTML
    )
      .then(response => {
        const $questionCommentList = $(
          '.js-question-comments-list',
          this.$context
        );

        $questionCommentList.prepend(response.data);
        const newQuestionComment = $(
          '.js-question-comment',
          $questionCommentList
        ).get(0);
        new QuestionComment(newQuestionComment);

        $('html, body').animate(
          { scrollTop: $questionCommentList.offset().top - 40 },
          700
        );

        EventManager.publish(`questionComment.${this.questionId}.saved`);
        EventManager.publish(
          `questionBelt.${this.questionId}.comments.updateTotal`,
          1
        );
        toastr.success('Comentário enviado com sucesso');
      })
      .catch(() => {
        EventManager.publish(`questionComment.${this.questionId}.failed`, {
          commentHTML: data.commentHTML
        });
      });
  }

  updateComment(event, data) {
    QuestionCommentEditor.updateAndRender(
      this.questionId,
      data.commentId,
      data.commentHTML
    )
      .then(response => {
        const html = response.data;
        window.editedInfo = html;

        const content = $(html).find('.js-question-comment-text').html();
        const $questionComment = $(
          `#question-comment-${data.commentId}`,
          this.$context
        );

        $questionComment.find('.js-question-comment-text').html(content);

        EventManager.publish(`questionComment.${this.questionId}.saved`);
        $('html, body').animate(
          { scrollTop: $questionComment.offset().top - 40 },
          700
        );
        toastr.success('Comentário atualizado com sucesso');
      })
      .catch(() => {
        EventManager.publish(`questionComment.${this.questionId}.failed`, {
          commentHTML: data.commentHTML
        });
      });
  }

  deleteComment(event, data) {
    ModalManager.open('#js-confirm-delete-comment-modal', res => {
      if (res === true) {
        QuestionComment.delete(this.questionId, data.commentId)
          .then(() => {
            const $questionCommentList = $(
              '.js-question-comments-list',
              this.$context
            );
            const $questionComment = $(
              `#question-comment-${data.commentId}`,
              $questionCommentList
            );
            $questionComment.fadeOut();

            toastr.success('Comentário excluido com sucesso');
            EventManager.publish(
              `questionBelt.${this.questionId}.comments.updateTotal`,
              -1
            );
          })
          .catch(() => {
            toastr.error(
              'Ops! Não foi possível excluir o comentário nesse momento!'
            );
          });
      }
    });
  }

  updateCounts(selector, sum) {
    const isPlainValue = typeof sum === 'number';

    const sumNumber = isPlainValue ? sum : sum.value;
    const $counter = $(
      selector,
      isPlainValue ? this.$context.parents('.q-question-belt') : sum.context
    );
    const newCount = parseInt($counter.html()) + sumNumber;

    $counter.html(newCount);
  }

  updateTotalCounter(event, sum) {
    this.updateCounts('.js-comments-count', sum);
  }

  updateTeachersCounter(event, sum) {
    this.updateCounts('.js-comments-teachers-count', sum);
  }

  async loadComments(params, replace = true) {
    const currentParams = this._getCommentsListElement().data().params;

    try {
      const html = await AjaxComponentLoader.load({
        component: 'questions/question_comments/comments_list',
        type: 'page_component',
        data: {
          ...currentParams,
          ...params
        },
        params: {
          page: params.page || 1
        }
      });

      this._renderComments(html, replace);
    } catch (res) {
      if (res.status !== 401 && res.status !== 0) {
        toastr.error('Ops! Não foi possível carregar os comentários!');
      }
    }
  }

  async loadMoreComments($btn) {
    const { orderBy } = $btn.data();
    const data = this._getCommentsListElement().data();

    if (!data?.nextPage) {
      return;
    }

    const { nextPage } = data;

    $btn.html('Carregando...');

    try {
      await this.loadComments({ page: nextPage, orderBy: orderBy }, false);
      $btn.remove();
    } catch (ex) {
      $btn.html('Carregar mais');
    }
  }

  async saveSortPreference(value) {
    await Thor.UserPreference.update(
      {},
      {
        data: {
          user_preferences: {
            questions_comments_order: value
          }
        }
      }
    );
  }

  async sort($btn) {
    const { orderBy } = $btn.data();

    try {
      await this.saveSortPreference(orderBy);
      await this.loadComments({ order_by: orderBy });
      $('.js-order-by-btn', this.$context).removeClass('active');
      $btn.addClass('active');
    } catch (ex) {
      toastr.error('Ops! Não foi possível ordenar os comentários!');
    }
  }
}

(function ($) {
  'use strict';

  $(document).on('componentLoaded:questions/question_comments', (e, data) => {
    const $questionCommentsEl = $('.js-question-comments');

    if ($questionCommentsEl.length > 0) {
      const questionComments = $('.js-question-comments', data.context).get(0);

      questionComments.questionCommentsInstance = new QuestionComments(
        questionComments
      );
    }
  });
})(jQuery);
